<template>
    <div id="Login" class="gradiant-bg">
        <v-container class="fill-height login-bg" fluid id="login-container">
            <v-card style="width: 450px" class="ml-auto mr-12">
                <div class="pl-12 pr-12 pb-12">
                    <div>
                        <img src="../assets/logo.png" width="200" class="mx-auto d-block" alt="">
                    </div>
                    <h4 style="margin-top: -20px;" class="text-h4  mb-6 font-weight-light text-uppercase text-center">Admin</h4>

                    <div v-if="signInMethod==='mobile'">
                        <div>
                            <v-text-field :rules="[rules.mobileLength,rules.mobileRequired]" @keyup.enter="signInMobile"
                                          autofocus
                                          label="Registered Mobile Number*" mask="##### #####" outline ref="mobile" required
                                          v-model="mobile"></v-text-field>
                        </div>
                        <v-btn :loading="loading" @click="signInMobile" class="primary mt-5 mx-auto d-block elevation-0">LOGIN</v-btn>
                    </div>

                    <div v-if="signInMethod==='otp'" class="mt-5">
                        <div class="text-left" style="color: #888;font-weight: 500;">OTP send to Mobile
                            <span>(+91){{mobile}}</span>
                        </div>
                        <div>
                            <v-text-field :rules="[v => !!v || 'OTP Required', v => v.length === 4 || 'OTP Must be 4 digit']"
                                          ref="otp" type="number" @keyup.enter="onVerifyOtp" autofocus label="Enter OTP*" outline v-model="otp"/>
                        </div>
                        <div class="mt-5">
                            <v-btn :loading="loading" @click="onVerifyOtp" class="primary elevation-0">VERIFY</v-btn>
                            <v-btn :disabled="timer!==0" @click="signInMobile" class="ml-2 elevation-0">RESEND OTP
                                {{timer?'('+timer+')':''}}
                            </v-btn>
                        </div>
                    </div>

                </div>
            </v-card>
        </v-container>
        <Snackbar :toaster="toaster"></Snackbar>
    </div>
</template>

<script>
  import Snackbar from '../components/Common/Snackbar'
  import Constants from '../Constants/Constants'
  import {wsLink} from "../vue-apollo";
  import NetworkCommunicator from '../plugins/NetworkResourceHandler'
  export default {
    name: 'Login',
    components: { Snackbar },
    data () {
      return {
        loading: false, toaster: {}, constants: Constants,
        mobile: '', otp: '', mobileToken: '',
        timer: 30, timeOut: null, signInMethod: 'mobile',
        rules: {
          mobileRequired: value => !!value || 'Mobile Required.',
          mobileLength: value => value.length === 10 || 'Mobile Must be 10 digit',
          /* otpLength: value => value.length === 4 || 'OTP Must be 4 digit', */
        },
      }
    },
    beforeCreate () {
      // if (localStorage.getItem('token') != undefined && localStorage.getItem('token') != '') {
      //   this.$router.replace({ path: '/login' })
      // }
    },
    methods: {
      async signInMobile () {
        let self = this
        if (this.mobile && this.mobile.length === 10) {
          self.loading = true
          let response = await NetworkCommunicator('POST', `${Constants.api_url}loginWithOtp`,
            { mobile: this.mobile, type: 'Admin' })
          if (response.flag) {
            self.timer = 30
            if (self.timeOut)
              clearInterval(self.timeOut)
            self.timeOut = setInterval(function () {
              if (self.timer !== 0)
                self.timer = parseInt(self.timer) - 1
            }, 1000)
            self.mobileToken = response.data.id
            self.toaster = { enable: true, color: 'green', message: response.message }
            self.signInMethod = 'otp'
            setTimeout(function () {
              self.$refs.otp.resetValidation()
            }, 100)
            self.loading = false
          } else {
            self.toaster = { enable: true, color: 'red', message: response.message }
            self.loading = false
          }
        }
      },
      onVerifyOtp(){
          if(this.$refs['otp'].validate()) this.verifyOtp()
      },
      async verifyOtp () {
        let self = this
        self.loading = true
        let response = await NetworkCommunicator('POST', `${Constants.api_url}verifyOtpLogin`,
          { id: this.mobileToken, otp: parseInt(this.otp), deviceInfo: {}, deviceType: 'Web', fcmToken: '' })
        if (response.flag) {
          self.toaster = { enable: true, color: 'green', message: response.message }
          localStorage.setItem('user', JSON.stringify(response.data.data))
          localStorage.setItem('token', response.data.token)
          let modules = response.data.moduleObj.sort((a, b) => a - b)
          this.$store.commit('setModules', modules)
          self.toaster = { enable: true, color: 'green', message: 'Logged in successfully.' }
          let accessibleUrls = modules.map(m => m.url);
          this.$store.commit('setAccessibleUrls', [...accessibleUrls, '/8140347287'])
          self.loading = false
          /*TODO: Close socket connection & reconnect will ensure a new connection with new token */
          wsLink.subscriptionClient.close();
          self.$router.push(accessibleUrls[0] || '/login')
        } else {
          self.toaster = { enable: true, color: 'red', message: response.message }
          self.loading = false
        }
      },
    },
  }
</script>

<style scoped>
#login-container{
    background-image: url("../assets/images/loginBg.jpg");
  background-size: cover;
  background-position: left top;
}
</style>
